import { Component, Input, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { ContactsService } from 'app/store/services/contacts.service';
import { ResponsesService } from 'app/store/services/responses.service';

import { Store } from '@ngrx/store';
import { IReducers } from 'app/store/reducers';

@Component({
  selector: 'app-qr-edit',
  templateUrl: './qr-edit.component.html',
  styleUrls: ['./qr-edit.component.scss'],
})
export class QrEditComponent implements OnInit {
  @Input() inputForm: FormGroup;

  public data;

  formReady = false;
  dataReady = false;
  replies;
  editorConfig = {};

  constructor(
    public datepipe: DatePipe,
    private store: Store<IReducers>,
    private contactsService: ContactsService,
    private responsesService: ResponsesService,
  ) {
  }

  ngOnInit() {
    this.responsesService
      .getAction(this.data.row.action_id)
      .subscribe(response => {
        const action = response;
        console.log(action);

        this.contactsService.getReplies().subscribe(res => {
          this.replies = res.items;
          this.editorConfig = this.onPreInit(res.items);

          switch (this.data.type) {
            case 'cycle':
              this.inputForm.addControl(
                'subject',
                new FormControl(action.subject, Validators.required),
              );
              this.inputForm.addControl(
                'reply_content',
                new FormControl(action.reply_content),
              );
              this.formReady = true;
              this.dataReady = true;
              break;
            case 'followup':
              break;
          }
        });
      });
  }

  onPreInit(replies) {
    return {
      toolbar:
        'quick_response | undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent',
      indent: false,
      plugins: 'link lists',
      setup(editor) {
        /* Menu items are recreated when the menu is closed and opened, so we need
                   a variable to store the toggle menu item state. */
        const items = replies.map(item => {
          return {
            type: 'menuitem',
            text: item.name,
            onAction() {
              editor.insertContent(item.response);
            },
          };
        });
        editor.ui.registry.addMenuButton('quick_response', {
          text: 'Select Quick Response',
          fetch(callback) {
            callback(items);
          },
        });
      },
    };
  }

  onEditorInit(event) {
    // this.editor.writeValue(this.initialSignature);
    // this.signatureForm.get('signature').setValue(this.initialSignature);
  }
}
